import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { GetSportIcon } from 'assets/icons';
import { LiveDetailsState, LiveMainState } from 'features/live/interface/live';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavigationItemLive from './navigationItemLive';

interface NavigationAccordionProps {
	item: LiveMainState;
	liveSportId: number | undefined;
}

const NavigationLiveAccordion = ({ item, liveSportId }: NavigationAccordionProps) => {
	const [expand, setExpand] = useState(false);
	const location = useLocation();

	const expandToggle = () => {
		setExpand(!expand);
	};

	useEffect(() => {
		setExpand(false);
		if (liveSportId === item.sportId) {
			setExpand(true);
		}
	}, [liveSportId, location, item.sportId]);

	return (
		<>
			<Accordion key={`${item.sportId}`} className="navigation__accordion" expanded={expand}>
				<AccordionSummary onClick={expandToggle} className={`navigation__accordion__summary`} data-cy="sport-navigation">
					<GetSportIcon id={item.sportId} className="navigation__icon" />
					{item.sportName}
					<div className="navigation__count">{item.events?.length}</div>
				</AccordionSummary>
				<AccordionDetails className="navigation__accordion__details">
					{item.events.map((event: LiveDetailsState) => {
						return <NavigationItemLive key={event.eventId} eventsListDetails={event} />;
					})}
				</AccordionDetails>
			</Accordion>
		</>
	);
};

export default NavigationLiveAccordion;
